export default "/lbp-static.37ef76c3cbe237dbc74831a2615357c7.png";